import { useAnonymousId } from "./contexts/AnonymousIdContext"
import { DeepLinkEvents } from "./events"
import { getPlatformProperties } from "./helpers/platform"
import { Amplitude } from "./libs/amplitude/amplitude"
import { Segment } from "./libs/segment/segment"
import type { UniversalAnalytics } from "./types"

const Analytics: UniversalAnalytics = {
  setup: async (...args) => {
    await Promise.all([Segment.setup(...args), Amplitude.setup(...args)])
  },
  page: async (...args) => {
    await Promise.all([Segment.page(...args), Amplitude.page(...args)])
  },
  screen: async (...args) => {
    await Promise.all([Segment.screen(...args), Amplitude.screen(...args)])
  },
  track: async (...args) => {
    await Promise.all([Segment.track(...args), Amplitude.track(...args)])
  },
  identify: async (...args) => {
    await Promise.all([Segment.identify(...args), Amplitude.identify(...args)])
  },
  reset: async () => {
    await Promise.all([Segment.reset(), Amplitude.reset()])
  },
  setAnonymousId: async (...args) => {
    await Promise.all([Segment.setAnonymousId(...args), Amplitude.setAnonymousId(...args)])
  },
  getUser: () => {
    return Segment.getUser()
  },
}

useAnonymousId.subscribe((state, prevState) => {
  if (state.anonymousId !== prevState.anonymousId) {
    void Analytics.setAnonymousId(state.anonymousId)
    void Analytics.identify(undefined, {})
    void Analytics.track(DeepLinkEvents.AnonymousIDSet, { anonymousId: state.anonymousId })
  }
})

export { Analytics, getPlatformProperties }
